import {BookingResource} from './resources'

export default {
  doBookingAction (data) {
    return BookingResource.doBookingAction(data)
  },
  getBookingData (data) {
    return BookingResource.getBookingData(data)
  },
  getInsuranceData (data) {
    return BookingResource.getInsuranceData(data)
  },
}
